import { useMemo } from "react";
import { isArray, isEmpty } from "lodash";

const tag = {
    standard: "Standard",
    rejected: "Rejected",
};

const WIPSTATE = "from completed to to-do";

export const useTasksByStatus = (tasks) => {
    const stateEquals = (stateData) => (state) => {
        if (isArray(stateData)) {
            return stateData.includes(state);
        }

        return state === stateData;
    };

    const stateDiffers = (stateData) => (state) => {
        if (isArray(stateData)) {
            return !stateData.includes(state);
        }

        return state !== stateData;
    };

    const isTaskGrouped = (value, arr) => arr.some((subarray) => subarray.includes(value));

    const filterTag = (tagName, compareOperation) => {
        return [
            tasks.filter(({ tags, stateData }) => {
                if (!tagName) {
                    return compareOperation(stateData);
                }

                return tags.includes(tagName) && compareOperation(stateData);
            }),
        ];
    };

    const addRedoNumber = (items) => {
        //Group together tasks with the same label description
        //Reverse array so numbers are descending
        const counts = {};
        items[0].reverse().forEach((item) => {
            counts[item.description] = (counts[item.description] || 0) + 1;
            //Add count to description
            item.description = item.description.replace("-", " ") + ` ${counts[item.description]}`;
        });
    };

    return useMemo(() => {
        const completedRedos = filterTag(tag.rejected, stateEquals(tag.rejected.toLowerCase()));

        return tasks.reduce((taskAcc, currentTask, index, allTasks) => {
            // Check for truthy index values instead of mapping to prevent duplicated tasks
            if (index === 0) {
                return taskAcc.concat(filterTag(null, stateEquals([null, WIPSTATE])));
            }

            // Do not build this subarray if the task array only has three or four items
            if (index === allTasks.length - taskAcc[0].length) {
                return taskAcc.concat(filterTag(tag.standard, stateDiffers([null, WIPSTATE])));
            }

            // Group together completed redo tasks
            if (!isTaskGrouped(currentTask, taskAcc) && completedRedos.length > 0) {
                addRedoNumber(completedRedos);

                if (isEmpty(completedRedos[0])) {
                    return taskAcc;
                }

                //Reverse array back to original descending
                completedRedos[0].sort((a, b) => new Date(b.taskUpdatedOn) - new Date(a.taskUpdatedOn));

                return taskAcc.concat(completedRedos);
            }

            // Add fixed sort for current tasks
            taskAcc[0].sort((a, b) => b.taskType.localeCompare(a.taskType));

            return taskAcc;
        }, []);
    }, [tasks]);
};
